import { Text } from '@smuchile/pkg-unimarc-components'
import { useOrder } from '@smuchile/pkg-unimarc-hooks'

export const TextSecond = () => {
  const { data } = useOrder({ oldOrders: true })

  return (
    <>
      <Text textAlign='center'>
        Una vez confirmada la cancelación, te enviaremos un correo a:
      </Text>
      <Text
        fontWeight='medium'
        textAlign='center'
      >
        {data?.data?.clientProfileData?.email}
      </Text>
    </>
  )
}
